<div *ngIf="facade.loading()">Loading Parents...</div>

<p *ngIf="!facade.loading() && facade.loadError()" class="empty-state error-state">
	{{ facade.loadError() }}
</p>

<ng-container *ngIf="!facade.loading() && !facade.loadError()">
	<section *ngIf="facade.schedule() as s">
		<table *ngIf="facade.rosterRows().length" class="parents-roster">
			<thead>
				<tr>
					<th>Name</th>
					<th class="col-check" title="Greeted">☐</th>
					<th class="col-sum" title="Classes attended">Σ</th>
					<th class="col-end">End Date</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let row of facade.rosterRows()"
					[class.student-row]="row.kind === 'student'"
					[class.parent-row]="row.kind === 'parent'"
				>
					<td
						class="name-cell"
						[class.student-name]="row.kind === 'student'"
						[class.parent-name]="row.kind === 'parent'"
					>
						{{ row.name }}
					</td>
					<td class="col-check">
						<input
							*ngIf="row.kind === 'parent'"
							type="checkbox"
							[checked]="facade.isParentGreeted(row.parentId)"
							[disabled]="facade.isGreetingBusy(row.parentId)"
							(change)="facade.onGreetingToggle(row.parentId, $any($event.target).checked)"
						/>
					</td>
					<td class="col-sum">
						<ng-container *ngIf="row.kind === 'student' && row.isTrial">
							{{ row.classesAttended ?? 0 }}
						</ng-container>
					</td>
					<td class="col-end">
						<ng-container *ngIf="row.kind === 'student' && row.isTrial">
							{{ row.endDateDisplay || '-' }}
						</ng-container>
					</td>
				</tr>
			</tbody>
		</table>

		<p *ngIf="!facade.rosterRows().length" class="empty-state">No students on this schedule.</p>
	</section>
</ng-container>

<div *ngIf="!facade.loading() && !facade.loadError() && !facade.schedule()">No schedule found.</div>
